__turbopack_context__.v({
  "anim": "index-module-scss-module__n0kx6a__anim",
  "arrow": "index-module-scss-module__n0kx6a__arrow",
  "bounceBookingListIn": "index-module-scss-module__n0kx6a__bounceBookingListIn",
  "disabled": "index-module-scss-module__n0kx6a__disabled",
  "grid": "index-module-scss-module__n0kx6a__grid",
  "gridDate": "index-module-scss-module__n0kx6a__gridDate",
  "header": "index-module-scss-module__n0kx6a__header",
  "list": "index-module-scss-module__n0kx6a__list",
  "listWrapper": "index-module-scss-module__n0kx6a__listWrapper",
  "none": "index-module-scss-module__n0kx6a__none",
  "retry": "index-module-scss-module__n0kx6a__retry",
  "selected": "index-module-scss-module__n0kx6a__selected",
  "slot": "index-module-scss-module__n0kx6a__slot",
  "special": "index-module-scss-module__n0kx6a__special",
  "status": "index-module-scss-module__n0kx6a__status",
  "text": "index-module-scss-module__n0kx6a__text",
  "time": "index-module-scss-module__n0kx6a__time",
  "total": "index-module-scss-module__n0kx6a__total",
  "wrapper": "index-module-scss-module__n0kx6a__wrapper",
});
